<template>
  <v-toolbar app fixed class="toolbar primary white--text">
    <div class="the-toolbar__title">Меню</div>
    <v-spacer />
    <v-btn
      flat
      icon
      color="white"
      @click="$emit('themeChanged')"
    >
      <v-icon v-if="isThemeDark">light_mode</v-icon>
      <v-icon v-else>nightlight</v-icon>
    </v-btn>
    <div class="subheading mx-4">{{ userName }}</div>
    <v-divider inset vertical />
    <v-toolbar-items>
      <v-divider inset vertical />
      <v-btn flat color="accent" @click="exit">Выход</v-btn>
    </v-toolbar-items>
  </v-toolbar>
</template>

<script>
import { signOut } from '../../../../../api/auth'
import User from '../../../../../helpers/user'

export default {
  props: {
    isThemeDark: {
      type: Boolean
    }
  },
  computed: {
    userName () {
      return this.$store.getters.user && this.$store.getters.user.name || ''
    }
  },
  methods: {
    exit () {
      signOut().then()
      User.signOut()
      this.$store.commit('SET_AUTH_USER', null)
      this.$router.push('auth')
    }
  }
}
</script>

<style lang="scss" scoped>
.the-toolbar__title {
  width: 260px;
  height: 100%;
  position: absolute;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 25px;
  border-bottom: thin solid rgba(0, 0, 0, 0.12) !important;
}
</style>
